import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaFormSubmitSuccessPageComponent } from './pa-form-submit-success-page.component';

const routes: Routes = [
  {
    path: '',
    component: PaFormSubmitSuccessPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaFormSubmitSuccessPageRoutingModule {}
